import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiMutationHook } from '../../../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../../../common/queryClient/getMutationFn';

import { AlgorithmSourcesSchema } from '../schema/AlgorithmSourcesSchema';
import { AlgorithmUrl } from '../../query/AlgorithmUrl';
import {
  AlgorithmSourcesFormDataType,
  AlgorithmSourcesValidFormDataType,
} from '../schema/types';

const putAlgorithmSources = (
  id: number,
  algorithmSources: Partial<AlgorithmSourcesValidFormDataType>,
  headers?: HttpHeaders
) =>
  apiClient
    .put<AlgorithmSourcesFormDataType>(
      expand(AlgorithmUrl.SOURCES, { id }),
      AlgorithmSourcesSchema.parseMutationDto(algorithmSources),
      headers ? { headers } : undefined
    )
    .then((response) => response.data);

export const useMutateAlgorithmSourcesQuery = createApiMutationHook(
  ['algorithmSources'],
  getMutationFn(undefined, putAlgorithmSources)
);
